import clinicApi from './clinicApi';

export const clinicAuthService = {
  login: async (email, password) => {
    const response = await clinicApi.post('/login', { email, password });
    if (response.data.access_token) {
      localStorage.setItem('clinic_token', response.data.access_token);
      localStorage.setItem('clinic_user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  getProfile: async () => {
    const response = await clinicApi.get('/me');
    return response.data;
  },

  updateProfile: async (data) => {
    const response = await clinicApi.put('/profile', data);
    return response.data;
  },

  changePassword: async (data) => {
    const response = await clinicApi.post('/change-password', data);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('clinic_token');
    localStorage.removeItem('clinic_user');
    window.location.href = '/login';
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('clinic_token');
  },

  getUser: () => {
    const user = localStorage.getItem('clinic_user');
    return user ? JSON.parse(user) : null;
  },

  updateUserData: (userData) => {
    localStorage.setItem('clinic_user', JSON.stringify(userData));
  },
};

export const clinicService = {
  // Dashboard Stats
  getStats: async () => {
    const response = await clinicApi.get('/stats');
    return response.data;
  },

  // Profile Management
  updateProfile: async (data) => {
    const response = await clinicApi.put('/profile', data);
    return response.data;
  },

  changePassword: async (data) => {
    const response = await clinicApi.post('/change-password', data);
    return response.data;
  },

  // Doctor Management
  getDoctors: async (params = {}) => {
    const response = await clinicApi.get('/doctors', { params });
    return response.data;
  },

  createDoctor: async (data) => {
    const response = await clinicApi.post('/doctors', data);
    return response.data;
  },

  updateDoctor: async (id, data) => {
    const response = await clinicApi.put(`/doctors/${id}`, data);
    return response.data;
  },

  deleteDoctor: async (id) => {
    const response = await clinicApi.delete(`/doctors/${id}`);
    return response.data;
  },

  // Patient Management
  getPatients: async (params = {}) => {
    const response = await clinicApi.get('/patients', { params });
    return response.data;
  },

  createPatient: async (data) => {
    const response = await clinicApi.post('/patients', data);
    return response.data;
  },

  updatePatient: async (id, data) => {
    const response = await clinicApi.put(`/patients/${id}`, data);
    return response.data;
  },

  deletePatient: async (id) => {
    const response = await clinicApi.delete(`/patients/${id}`);
    return response.data;
  },

  // Staff Management
  getStaff: async (params = {}) => {
    const response = await clinicApi.get('/staff', { params });
    return response.data;
  },

  createStaff: async (data) => {
    const response = await clinicApi.post('/staff', data);
    return response.data;
  },

  updateStaff: async (id, data) => {
    const response = await clinicApi.put(`/staff/${id}`, data);
    return response.data;
  },

  deleteStaff: async (id) => {
    const response = await clinicApi.delete(`/staff/${id}`);
    return response.data;
  },

  // Appointment Management
  getAppointments: async (params = {}) => {
    console.log('Calling appointments API with params:', params);
    const response = await clinicApi.get('/appointments', { params });
    console.log('Appointments API response:', response);
    console.log('Appointments API response.data:', response.data);
    return response.data;
  },

  createAppointment: async (data) => {
    const response = await clinicApi.post('/appointments', data);
    return response.data;
  },

  updateAppointment: async (id, data) => {
    const response = await clinicApi.put(`/appointments/${id}`, data);
    return response.data;
  },

  updateAppointmentStatus: async (id, status) => {
    const response = await clinicApi.put(`/appointments/${id}/status`, { status });
    return response.data;
  },

  deleteAppointment: async (id) => {
    const response = await clinicApi.delete(`/appointments/${id}`);
    return response.data;
  },

  // Invoice Management
  getInvoices: async (params = {}) => {
    const response = await clinicApi.get('/invoices', { params });
    return response.data;
  },

  createInvoice: async (data) => {
    const response = await clinicApi.post('/invoices', data);
    return response.data;
  },

  updateInvoice: async (id, data) => {
    const response = await clinicApi.put(`/invoices/${id}`, data);
    return response.data;
  },

  deleteInvoice: async (id) => {
    const response = await clinicApi.delete(`/invoices/${id}`);
    return response.data;
  },

  generateInvoiceFromAppointment: async (appointmentId) => {
    const response = await clinicApi.post(`/invoices/generate/${appointmentId}`);
    return response.data;
  },
};
